import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, change,formValueSelector } from 'redux-form';
import { useNavigate, useLocation } from 'react-router-dom'; // Modern react-router hooks
import Logger from '../../../../util/Logger';
import * as jobActions from '../../../../actions/jobActions';
import { treatmentResultRecordsForm } from '../../../../constants/FormConstants';

import { withSortedReadings, withCalculatedFields } from './enhancers';

import TreatmentResultRecordsForm from './TreatmentResultRecordsForm';
import { compose, withProps } from 'recompose';



// mapStateToProps for Redux state connection
function mapStateToProps(state, ownProps) {
  
  return {
    initialValues: ownProps.currentTreatmentResultRecord || {},// Set initial values from props or fallback to an empty object
  };
}



// mapDispatchToProps for action dispatchers
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...jobActions, changeFieldValue: change },
      dispatch,
    ),
  };
}

// Higher-Order Component (HOC) composition
const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps), // Connect Redux state and actions
  withSortedReadings, // Apply sorted readings
  reduxForm({
    form: treatmentResultRecordsForm, // Form name in Redux
    enableReinitialize: true, // Allows reinitializing when initialValues changes
    onSubmitFail: (errors, dispatch, submitError) => {
      Logger.error(
        'We were unable to save the changes, please review the fields in red and try again.',
        submitError,
        'Log Row Record not saved',
      );
    },
  }),
  withCalculatedFields, // Apply calculated fields
);

const EnhancedTreatmentResultRecordsForm = enhance((props) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Pass navigate and location hooks to the form if required
  return (
    <TreatmentResultRecordsForm
      {...props}
      navigate={navigate}
      location={location}
      showMonitoring={false}
    />
  );
});

export default EnhancedTreatmentResultRecordsForm;
